export const INJECT_KEYS = {
  SIGN_UP_OPEN_DRAWER: "signUpOpenDrawer",
  TOGGLE_SIGN_UP: "toggleSignUp",
};
